import { ParticipantsIncidentQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/participantsIncidentList/ParticipantsIncidentQuery.type';
import { ParticipantsIncidentQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/participantsIncidentList/ParticipantsIncidentQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const participantsIncidentQueryOptions = ({
  enable = true,
  id,
  user = 'damaged',
  view_type = 'information',
}: {
  enable?: boolean;
} & ParticipantsIncidentQueryParamsType) =>
  queryOptions({
    queryKey: ['participants-incident', id, user],
    queryFn: () => ParticipantsIncidentQueryFunction({ id, user, view_type }),
    enabled: enable,

    select: (data) => {
      const damages = data?.damages?.length
        ? data.damages.map((item) => ({
            ...item,
            label: !item.is_active ? [] : item.label,
            action_list: Object.keys(item.action_list).reduce<string[]>(
              (acc, key) => {
                if (item.action_list[key as keyof typeof item.action_list]) {
                  acc.push(key);
                }

                return acc;
              },
              [],
            ),
          }))
        : [];
      return {
        damages,
        culprit: data.culprit ?? [],
      };
    },
  });
